import { render, staticRenderFns } from "./WeekPickers.vue?vue&type=template&id=28b46872&scoped=true&"
import script from "./WeekPickers.vue?vue&type=script&lang=js&"
export * from "./WeekPickers.vue?vue&type=script&lang=js&"
import style0 from "./WeekPickers.vue?vue&type=style&index=0&id=28b46872&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b46872",
  null
  
)

export default component.exports